export default __webpack_public_path__ + "static/media/lumix-2020-g100v-galleryimages-1-210129.81b41036.jpg";